import React from "react";
import {useSelector} from "react-redux";
import {uid} from "react-uid";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Icon, IconButton, makeStyles, Tooltip, Typography} from "@material-ui/core";
import {multiLanguageValue} from "../../../../Utils/lib";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        marginTop: 10,
    },
    itemContainer: {
        border: "1px solid #EAEFF1",
        borderRadius: 12,
        padding: 10,
        position: "relative"
    },
    itemContent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    linearProgressRoot: {
        height: 10,
        borderRadius: 3
    },
    closeIcon: {
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        right: 5,
        top: 5
    }
}))

const DroppedFilesList = ({droppedFiles, onRemoveFile, fileTypes, onChangeFileType, hideSelectType, isDisabled}) => {
    const {userLanguage} = useSelector(state => state.app)
    const classes = useStyles();
    return (
        <div className={classes.container}>
            {
                droppedFiles.map((file, i) => {
                    if(!file) return <></>

                    return (
                        <div className={classes.itemContainer} key={uid(file)}>
                            <div className={classes.itemContent}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: '5px',
                                    width: '50%'
                                }}>
                                    <Icon fontSize={"large"} color={'primary'}>
                                        description
                                    </Icon>
                                    <div>
                                        <Typography
                                            variant={"body2"}>
                                            {multiLanguageValue(file?.name, userLanguage)}
                                        </Typography>
                                        <div style={{display: 'flex', alignItems: 'center', gap: 5}}>

                                            {(file.progress === 100 || file.errored) && (
                                                <Icon fontSize={"small"} style={{color: file.errored ? 'red' : 'green'}}>
                                                    {file.errored ? "error" : "check_circle"}
                                                </Icon>
                                            )}

                                            <Typography
                                                style={{
                                                    fontSize: 12
                                                }}
                                                color={file.errored ? "error" : "textSecondary"}
                                                variant={"body2"}>
                                                {file.errored ? "Upload filed" : file.size}
                                            </Typography>
                                        </div>
                                    </div>
                                </div>

                                <div className={classes.closeIcon}
                                     style={{paddingLeft: 5, display: 'flex', alignItems: 'center'}}
                                >
                                    <Tooltip title={'Remove file'}>
                                        <IconButton size={"small"}
                                                    disabled={isDisabled}
                                                    onClick={() => onRemoveFile(i)}>
                                            <Icon fontSize={"small"}>
                                                close
                                            </Icon>
                                        </IconButton>
                                    </Tooltip>
                                </div>

                            </div>
                            {(!file.errored && file.progress !== 100) && (
                                <div style={{width: '100%'}}>
                                    <div>
                                        <Box display="flex" alignItems="center">
                                            <Box width="100%" mr={1}>
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={Number(file.progress || 0)}
                                                    classes={{root: classes.linearProgressRoot}}
                                                />
                                            </Box>
                                            <Box minWidth={35}>
                                                <Typography variant="body2" color="textSecondary">{`${Math.round(
                                                    Number(file.progress || 0),
                                                )}%`}</Typography>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
                })
            }
        </div>
    )
}

export default DroppedFilesList